<template>
    <div>
        <Main title="Activations Scheduler" subtitle="Scheduler Items">
            <template v-slot:buttons>
                <div class="btn-toolbar float-right" role="toolbar" aria-label="Create">
                    <a @click="createNewScheduler()" class="btn btn-success ml-1 text-white" data-toggle="tooltip" title="Create New"><i class="fas fa-plus-circle"></i> Create</a>
                </div><!--btn-toolbar-->
            </template>

            <template v-slot:table>
                <div class="row">
                    <div class="col-4">
                        <div class="input-group">
                            <v-text-field
                                v-model="searchData.q"
                                clearable
                                clear-icon="mdi-close"
                                type="text"
                                color="info"
                                placeholder="Search by scheduler name or ID"
                            >
                            </v-text-field>
                        </div>
                    </div>
                </div>
                <v-app>
                    <TableLoading cols="9" v-if="loading"></TableLoading>

                    <div class="table-responsive mt-4" v-if="!loading">
                        <table class="table">
                            <thead>
                            <tr>
                                <th>ID</th>
                                <th>Schedule Name</th>
                                <th>Activations data set</th>
                                <th>Schedule Info</th>
                                <th>Recency</th>
                                <th>Activation</th>
                                <th>Status</th>
                                <th>Created At</th>
                                <th>Actions</th>
                            </tr>
                            </thead>
                            <tbody>

                            <tr v-if="!schedules.length">
                                <td class="text-center" colspan="9">No schedulers found, please try creating one</td>
                            </tr>

                            <tr v-for="item in schedules" :key="item.id" v-if="schedules.length" class="schedule-row">
                                <td>{{ item.id }}</td>
                                <td>{{ item.name }}</td>
                                <td>
                                    <ul class="list-unstyled"><li><strong>Query Operator: </strong>{{ item.query || '' }}</li></ul>
                                    <ul class="list-unstyled" v-for="(datasetItem, index) in item.dataset" :key="index" v-if="item.dataset">
                                        <li>Analysis Type: <strong>{{ datasetItem.analysistype || '' }}</strong></li>
                                        <li v-if="datasetItem.analysistype !== 'Cohorts' && datasetItem.signalproviders.length">{{ datasetItem.signalproviders.length }} Signal Providers</li>
                                        <li v-if="datasetItem.analysistype !== 'Cohorts' && datasetItem.categories.length">{{ datasetItem.categories.length }} Categories</li>
                                        <li v-if="datasetItem.analysistype !== 'Cohorts' && datasetItem.analysisdata.length">{{ datasetItem.analysisdata.length }} {{ datasetItem.analysistype }} Data</li>
                                        <li v-if="datasetItem.analysistype === 'POI' && datasetItem.locations.length">{{ datasetItem.locations.length }} Locations</li>
                                        <li v-if="['POI', 'Anonymized'].includes(datasetItem.analysistype) && datasetItem.countries.length">{{ datasetItem.countries.length }} Countries</li>
                                        <li v-if="datasetItem.analysistype === 'POI' && datasetItem.states.length">{{ datasetItem.states.length }} States</li>
                                        <li v-if="datasetItem.analysistype === 'POI' && datasetItem.dmas.length">{{ datasetItem.dmas.length }} DMAs</li>
                                        <li v-if="datasetItem.analysistype === 'POI' && datasetItem.cities.length">{{ datasetItem.cities.length }} Cities</li>
                                        <li v-if="datasetItem.analysistype === 'POI' && datasetItem.zipcodes.length">{{ datasetItem.zipcodes.length }} Zip Codes</li>
                                        <li v-if="datasetItem.analysistype === 'Cohorts'">Name: {{ datasetItem.cohort_name }}</li>

                                        <li v-if="datasetItem.analysistype === 'Apps' && datasetItem.apps_categories.length">{{ datasetItem.apps_categories.length }} Categories</li>
                                        <li v-if="datasetItem.analysistype === 'Apps' && datasetItem.apps_tags.length">{{ datasetItem.apps_tags.length }} Tags</li>
                                        <li v-if="datasetItem.analysistype === 'Apps' && datasetItem.apps_bundle_ids.length">{{ datasetItem.apps_bundle_ids.length }} App Names</li>
                                        <li v-if="datasetItem.analysistype === 'Apps' && datasetItem.apps_device_os.length">{{ datasetItem.apps_device_os.length }} Device OS</li>
                                        <li v-if="datasetItem.analysistype === 'Apps' && datasetItem.countries.length">{{ datasetItem.countries.length }} Countries</li>
                                    </ul>
                                </td>
                                <td>
                                    <div class="mb-2">
                                        <span class="d-block"><strong>Recurrence</strong></span>
                                        <span class="d-block">
                                            <span v-if="item.schedule.recurrence.frequency == 'daily'">Every day</span>
                                            <span v-if="item.schedule.recurrence.frequency == 'weekly'">Every {{ days[new Date(item.schedule.recurrence.start).getDay()] }}</span>
                                            <span v-if="item.schedule.recurrence.frequency == 'bi-weekly'">Bi-Weekly on {{ days[new Date(item.schedule.recurrence.start).getDay()] }}</span>
                                            <span v-if="item.schedule.recurrence.frequency == 'monthly'">Every {{ new Date(item.schedule.recurrence.start).getDate() }}{{ nthDate(new Date(item.schedule.recurrence.start).getDate()) }} of a month</span>
                                        </span>
                                    </div>
                                    <div class="mb-2">
                                        <span class="d-block"><strong>Duration</strong></span>
                                        <span class="d-block" v-if="item.schedule.recurrence.cycles.recurrence_type == 3">{{ item.schedule.recurrence.period }} day</span>
                                        <span class="d-block" v-if="item.schedule.recurrence.cycles.recurrence_type != 3">{{ item.schedule.recurrence.cycles.recurrence_type == 2 ? 'Last Month' : 'Last Week' }}</span>
                                    </div>
                                    <div class="mb-2">
                                        <span class="d-block"><strong>Expire</strong></span>
                                        <span class="d-block" v-if="item.schedule.recurrence.ending.type == 1">Never ending</span>
                                        <span class="d-block" v-if="item.schedule.recurrence.ending.type == 2">After {{ item.schedule.recurrence.ending.data }} recurrences</span>
                                        <span class="d-block" v-if="item.schedule.recurrence.ending.type == 3">On {{ item.schedule.recurrence.ending.data }}</span>
                                    </div>
                                    <div class="mb-2">
                                        <span class="d-block">
                                            <strong>Next Run</strong>
                                        </span>
                                        <span class="d-block" v-if="item.schedule.recurrence.cycles.next_run.available == 1 && item.status">
                                            {{ item.schedule.recurrence.cycles.next_run.time }}
                                            <small class="d-block">Timezone: {{ item.schedule.recurrence.timezone }}</small>
                                        </span>
                                        <span class="d-block font-italic" v-if="item.schedule.recurrence.cycles.next_run.available == 0 || !item.status">Not available</span>
                                    </div>
                                </td>
                                <td>
                                    <div class="mb-2">
                                        <span class="d-block"><strong>Latest Analysis</strong></span>
                                        <span class="d-block" v-if="item.schedule.recurrence.cycles.last_run.available == 1">{{ item.schedule.recurrence.cycles.last_run.data.date_start + ' - ' + item.schedule.recurrence.cycles.last_run.data.date_end }}</span>
                                        <span class="d-block font-italic" v-if="item.schedule.recurrence.cycles.last_run.available == 0">Not available</span>
                                    </div>
                                    <div class="mb-2">
                                        <span class="d-block"><strong>Next Analysis</strong></span>
                                        <span class="d-block" v-if="item.schedule.recurrence.cycles.next_run.available == 1">{{ item.schedule.recurrence.cycles.next_run.data.date_start + ' - ' + item.schedule.recurrence.cycles.next_run.data.date_end }}</span>
                                        <span class="d-block font-italic" v-if="item.schedule.recurrence.cycles.next_run.available == 0">Not available</span>
                                    </div>
                                    <div>
                                        <span class="d-block"><strong>Total Analyses</strong></span>
                                        <span class="d-block">
                                            <span>{{ item.schedule.recurrence.cycles.done }}</span> / <span v-if="item.schedule.recurrence.cycles.available != 0">{{ item.schedule.recurrence.cycles.available }}</span>
                                            <span v-if="item.schedule.recurrence.cycles.available == 0">&infin;</span>
                                        </span>
                                    </div>
                                </td>
                                <td>
                                    <div v-if="checkObject(item.schedule.activation) && item.schedule.activation.endpoint">
                                        <div class="mb-2">
                                            <span class="d-block"><strong>Partner Name</strong></span>
                                            <span class="d-block">{{ item.schedule.activation.endpoint.partner_name }}</span>
                                        </div>
                                        <div class="mb-2">
                                            <span class="d-block"><strong>Pricing Model</strong></span>
                                            <span class="d-block">{{ item.schedule.activation.endpoint.pricing_model }}</span>
                                        </div>
                                        <div class="mb-2">
                                            <span class="d-block"><strong>Limit</strong></span>
                                            <span class="d-block" v-if="item.schedule.activation.limit > 0">{{ new Intl.NumberFormat().format(item.schedule.activation.limit) }} EIDs</span>
                                            <span class="d-block font-italic" v-else>Unlimited EIDs</span>
                                        </div>
                                    </div>
                                    <div v-else>
                                        <v-tooltip top color="primary">
                                            <template v-slot:activator="{ on, attrs }">
                                                <i v-bind="attrs"
                                                   v-on="on"
                                                   class="fas fa-ban text-danger"></i>
                                            </template>
                                            <span>Auto activation feature is not enabled</span>
                                        </v-tooltip>
                                    </div>
                                </td>
                                <td>
                                    <span class="badge" :class="getBadgeStatusClassName(item.status_color)">{{ item.string_status }}</span>
                                </td>
                                <td>{{ item.created_at }}</td>
                                <td class="btn-td">
                                    <div class="btn-group" role="group" aria-label="User Actions">

                                        <v-tooltip top color="primary">
                                            <template v-slot:activator="{ on, attrs }">
                                                <button
                                                    v-bind="attrs"
                                                    v-on="on"
                                                    @click="showScheduler(item)"
                                                    class="btn btn-info">
                                                    <i class="fas fa-eye"></i>
                                                </button>
                                            </template>
                                            <span>Show more details</span>
                                        </v-tooltip>

                                        <v-tooltip top color="primary">
                                            <template v-slot:activator="{ on, attrs }">
                                                <button
                                                    v-bind="attrs"
                                                    v-on="on"
                                                    @click="editScheduler(item)"
                                                    :disabled="item.status !== 1"
                                                    class="btn btn-primary">
                                                    <i class="fas fa-edit"></i>
                                                </button>
                                            </template>
                                            <span>Edit Scheduler</span>
                                        </v-tooltip>

                                        <v-tooltip top color="primary"
                                                   v-if="item.status === 1"
                                        >
                                            <template v-slot:activator="{ on, attrs }">
                                                <button
                                                    v-bind="attrs"
                                                    v-on="on"
                                                    @click="showConfirmationModal(item, 'Deactivate Scheduler', 'deactivateScheduler')"
                                                    class="btn btn-dark">
                                                    <i class="fas fa-ban"></i>
                                                </button>
                                            </template>
                                            <span>Deactivate the scheduler</span>
                                        </v-tooltip>

                                        <v-tooltip top color="primary"
                                                   v-if="item.status === 0"
                                        >
                                            <template v-slot:activator="{ on, attrs }">
                                                <button
                                                    v-bind="attrs"
                                                    v-on="on"
                                                    @click="showConfirmationModal(item, 'Activate Scheduler', 'activateScheduler')"
                                                    class="btn btn-success">
                                                    <i class="fas fa-check"></i>
                                                </button>
                                            </template>
                                            <span>Activate the scheduler</span>
                                        </v-tooltip>

                                        <v-tooltip top color="primary"
                                                   v-if="item.status === 2"
                                        >
                                            <template v-slot:activator="{ on, attrs }">
                                                <button
                                                    v-bind="attrs"
                                                    v-on="on"
                                                    class="btn btn-dark">
                                                    <i class="fas fa-ban"></i>
                                                </button>
                                            </template>
                                            <span>This scheduler is fulfilled</span>
                                        </v-tooltip>

                                        <v-tooltip top color="primary">
                                            <template v-slot:activator="{ on, attrs }">
                                                <button
                                                    v-bind="attrs"
                                                    v-on="on"
                                                    @click="showDeleteModal(item)"
                                                    class="btn btn-danger">
                                                    <i class="fas fa-trash"></i>
                                                </button>
                                            </template>
                                            <span>Delete the scheduler</span>
                                        </v-tooltip>
                                    </div>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </v-app>
            </template>
        </Main>

        <ConfirmationModal v-if="confirmationModalDialog" :text="confirmationItem.text" :action="confirmationItem.action" v-on:confirmedModal="confirmedModal($event)"></ConfirmationModal>
        <ShowSchedulerItem v-if="showSchedulerItem"></ShowSchedulerItem>
        <DeleteModal v-if="deleteModalDialog"></DeleteModal>
        <CreateNewScheduler v-if="$store.getters['CreateAudienceStore/getSchedulerModalStatus']"></CreateNewScheduler>
        <EditExistingScheduler v-if="$store.getters['CreateAudienceStore/getSchedulerEditModalStatus']"></EditExistingScheduler>
    </div>
</template>

<script>
import mixins from "../../mixin";
import Main from '../../components/Main'
import TableLoading from "../../components/general/TableLoading";
import DeleteModal from "../../components/general/DeleteModal";
import api from "../../api/analyses/scheduler";
import CreateNewScheduler from "../../components/analyses/CreateNewScheduler";
import ConfirmationModal from "../../components/general/ConfirmationModal";
import ShowSchedulerItem from "../../components/analyses/ShowSchedulerItem";
import EditExistingScheduler from "../../components/analyses/EditExistingScheduler.vue";

export default {
    name: "ActivationScheduler",
    mixins: [mixins],
    data: () => ({
        schedules: [],
        searchData: {
            q: '',
            loading: false,
        },

        days: [
            'Sunday',
            'Monday',
            'Tuesday',
            'Wednesday',
            'Thursday',
            'Friday',
            'Saturday'
        ],

        showScheduleDialog: false,
        loading: true,

        deleteModalDialog: false,
        deletingSchedule: [],

        showSchedulerItem: false,
        showingScheduler: '',

        confirmationModalDialog: false,
        confirmationItem: {
            'item': '',
            'text': '',
            'action': ''
        }
    }),
    components: {
        EditExistingScheduler,
        ShowSchedulerItem,
        ConfirmationModal,
        TableLoading,
        DeleteModal,
        Main,
        CreateNewScheduler
    },
    methods: {
        async fetchData() {
            await api.getAllSchedules({
                q: this.searchData.q,
            })
                .then(res => {
                    this.schedules = res.data
                    this.loading = false
                })
                .catch(e => {
                    this.$toast.open({
                        message: e.response.data.message,
                        type: "error",
                    })
                })
        },
        showConfirmationModal(item, text, action) {
            this.confirmationItem.item = item
            this.confirmationItem.text = text
            this.confirmationItem.action = action
            this.confirmationModalDialog = true
        },
        showDeleteModal(item) {
            this.deletingSchedule = item
            this.deleteModalDialog = true
        },
        createNewScheduler() {
            this.$store.commit('CreateAudienceStore/SET_SCHEDULER_MODAL', true)
        },
        confirmedModal(event) {
            if (event === 'activateScheduler') {
                this.activateScheduler()
            } else if (event === 'deactivateScheduler') {
                this.deactivateScheduler()
            }
        },
        closeConfirmModal() {
            this.confirmationModalDialog = false
            this.confirmationItem = {}
        },
        showScheduler(scheduler) {
            this.showingScheduler = scheduler.id
            this.showSchedulerItem = true
            if ((window.location !== window.location + '/item/' + scheduler.id + '/show') && (window.location.href.split('/').slice(-1)[0] !== 'show')) {
                window.history.pushState({}, null, window.location + '/item/' + scheduler.id + '/show');
            }
        },
        editScheduler(scheduler) {
            this.$store.commit('CreateAudienceStore/SET_SCHEDULER_EDITING_ID', scheduler.id)
            this.$store.commit('CreateAudienceStore/SET_SCHEDULER_EDIT_MODAL', true)
        },
        async deleteItem() {
            await api.deleteSchedule({
                id: this.deletingSchedule.id,
            })
            .then(res => {
                this.$toast.open({
                    message: res.data.message,
                    type: "success",
                })
                this.deleteModalDialog = false
                this.deletingSchedule = []
                this.fetchData()
            })
            .catch(e => {
                this.$toast.open({
                    message: e.response.data.message,
                    type: "error",
                })
                this.deleteModalDialog = false
                this.deletingSchedule = []
            })
        },
        async activateScheduler() {
            await api.activateSchedule({
                id: this.confirmationItem.item.id
            })
            .then(res => {
                this.$toast.open({
                    message: res.data.message,
                    type: "success",
                })
                this.confirmationItem = {}
                this.confirmationModalDialog = false
                this.fetchData()
            })
            .catch(e => {
                this.$toast.open({
                    message: e.response.data.message,
                    type: "error",
                })
                this.confirmationModalDialog = false
                this.confirmationItem = {}
            })
        },
        async deactivateScheduler() {
            await api.deactivateSchedule({
                id: this.confirmationItem.item.id
            })
            .then(res => {
                this.$toast.open({
                    message: res.data.message,
                    type: "success",
                })
                this.confirmationItem = []
                this.confirmationModalDialog = false
                this.fetchData()
            })
            .catch(e => {
                this.$toast.open({
                    message: e.response.data.message,
                    type: "error",
                })
                this.confirmationModalDialog = false
                this.confirmationItem = []
            })
        },
        fetchSchedulerById: _.debounce(function (id) {
            this.showScheduler({'id': id})
        }, 800),
        reFetchData: _.debounce(function () {
            this.fetchData()
        }, 2000),
        filterData: _.debounce(function() {
            this.fetchData()
            this.searchData.loading = false
        }, 800),
    },
    created() {
        this.fetchData()
        let id = window.location.href.split('/').slice(-2)[0]
        if (!isNaN(id)) {
            this.fetchSchedulerById(id)
        }
    },
    watch: {
        'searchData.q': function () {
            if (this.searchData.q == null) {
                this.searchData.q = ""
            }
            this.loading = true
            this.filterData()
        },
        '$store.getters.getCompanyId' : function (val) {
            if (val !== null) {
                window.Echo.private('schedulers-' + this.$store.getters.getCompanyId)
                    .listen('Backend\\Activation\\SchedulerUpdated', (e) => {
                        this.loading = true
                        this.reFetchData()
                    })
            }
        },
    },
    mounted() {

    }
}
</script>

<style scoped>

</style>